import { render, staticRenderFns } from "./HomepageLayout.vue?vue&type=template&id=00898150"
import script from "./HomepageLayout.vue?vue&type=script&lang=js"
export * from "./HomepageLayout.vue?vue&type=script&lang=js"
import style0 from "./HomepageLayout.vue?vue&type=style&index=0&id=00898150&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports